module.exports = __webpack_public_path__ + "media/newstyle/images/icons8-check-0ea31ba03baa5094f653c813c009670f.gif";